import {Injectable, TemplateRef} from '@angular/core';
import {PageTitleItemComponent} from 'app/shared/components/page-title-item/page-title-item.component';
import {BehaviorSubject} from 'rxjs';
import {boolDevFlag} from 'test-helpers/dev-flags';
import {getSessionStorage} from '../../../pollyfills/storagePolyfill';
import {AuthService} from 'app/core/services/auth.service';
import {IntercomService} from 'app/core/services/intercom.service';

@Injectable({
    providedIn: 'root',
})
export class LayoutService {
    sideBar?: TemplateRef<any>;
    headerContent?: TemplateRef<any>;

    get isSideBarVisible(): boolean {
        return boolDevFlag('apd_isSideBarVisible', true, this.sessionStorage);
    }

    set isSideBarVisible(v: boolean) {
        this.sessionStorage.setItem('apd_isSideBarVisible', v ? '1' : '0');
    }

    title$ = new BehaviorSubject<string>('');
    frameWithoutPaddings$ = new BehaviorSubject<boolean>(false);
    visibleMobFooter$ = new BehaviorSubject<boolean>(true);
    titleItems$ = new BehaviorSubject<Array<PageTitleItemComponent>>(null);
    forcedShowAsScrolled = true;

    reloadFrame$ = new BehaviorSubject<boolean>(false);
    footerVisible$ = new BehaviorSubject<boolean>(true);

    private sessionStorage = getSessionStorage();

    constructor(
        private auth: AuthService,
        private intercom: IntercomService
    ) {}

    hideFooter() {
        if (this.footerVisible$.getValue()) {
            this.footerVisible$.next(false);
            this.intercom.hide();
        }
    }

    showFooter() {
        if (!this.footerVisible$.getValue()) {
            this.footerVisible$.next(true);
            this.intercom.show();
        }
    }

    toggleSidebar(): void {
        this.isSideBarVisible = !this.isSideBarVisible;
        setTimeout(() => window.dispatchEvent(new Event('resize')), 0);
    }
}
